<template>
  <customModal :containersm="true" @closeModal="closeModal">
    <template #title>
      {{ editingId ? 'Update Visit Type' : 'Add Visit Type' }}
    </template>

    <template #body>
      <div class="row g-3">
        <div class="col-12 col-md-6">
          <label class="form-label">
            Visit Type Name
            <sup class="text-danger"><i class="fa fa-asterisk"></i></sup>
          </label>
          <input
            type="text"
            class="form-control"
            v-model="visitType.name"
          />
          <span v-if="formErrors.name" class="text-danger">
            {{ formErrors.name }}
          </span>
        </div>

        <div class="col-12 col-md-6 d-flex align-items-end">
          <div class="form-check mt-2">
            <input
              type="checkbox"
              class="form-check-input"
              id="activeVisitType"
              v-model="visitType.active"
            />
            <label class="form-check-label ms-2" for="activeVisitType">
              Active
            </label>
          </div>
        </div>

      </div>

      <!-- Footer -->
      <div class="text-end mt-4">
        <button
          class="save_btn px-4 py-1"
          @click="editingId ? updateVisitType() : createVisitType()"
        >
          {{ editingId ? 'Update' : 'Create' }}
        </button>
      </div>
    </template>
  </customModal>
</template>

<script src="./CraVisitTypeAddEditModal.js"></script>
